import {
  UseQueryResult,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getPaymentChannelsInput,
  getPaymentChannelInput,
  PaymentChannelLiteModel,
  PaymentChannelModel,
} from './model';

export function useGetPaymentChannels(
  input?: getPaymentChannelsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<PaymentChannelLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<PaymentChannelLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getPaymentChannels', input?.params],
      () =>
        QueryFetchFunction({
          url: 'payment-channels',
          params: input?.params,
        }),
      options,
    ),
    PaymentChannelLiteModel,
  );
}

export function useGetPaymentChannel(
  input?: getPaymentChannelInput,
  options?: UseQueryOptions<ApiResult<PaymentChannelModel>, ApiError>,
): UseQueryResult<ApiResult<PaymentChannelModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getPaymentChannel', input?.id],
      () => QueryFetchFunction({ url: `payment-channels/${input?.id}` }),
      options,
    ),
    PaymentChannelModel,
  );
}

export function getPaymentChannelsKey(input?: getPaymentChannelsInput) {
  return ['getPaymentChannels', input?.params].filter(Boolean);
}

export function getPaymentChannelKey(input?: getPaymentChannelInput) {
  return ['getPaymentChannel', input?.id].filter(Boolean);
}
